/**
 * Query set by sitecore when redirecting from protected routes. Needs to be
 * kept in sync with what they set.
 */
export const PROTECTED_ROUTE_RETURN_PATH_QUERY_PARAM = 'returnTo';

export const OIDC_REDIRECT_URL_AUTH_CODE_QUERY_PARAM = 'code';
export const OIDC_REDIRECT_URL_ERROR_QUERY_PARAM = 'error';
export const OIDC_REDIRECT_URL_IS_LOGIN_QUERY_PARAM = 'isLogin';
export const NOTIFY_LOGIN_USER_ACTION_QUERY_PARAM = 'notifyLoginUserAction';

/** Query to override PreferredSiteB2B cookie redirect. */
export const SKIP_PREFERRED_SITE_REDIRECT_QUERY_PARAM =
	'skipPreferredSiteRedirect';

/** Query to force private or company site in certain places. */
export const JURIDICAL_TYPE_QUERY_PARAM = 'juridicaltype';

/** Order confirmation and account order status/details. */
export const ORDER_ID_QUERY_PARAM = 'orderId';

export const JULA_PRO_USER_ACCEPTED_INVITE_QUERY_PARAM = 'acceptedInvitation';

/** Page header search and search page query. */
export const SEARCH_QUERY_PARAM = 'query';

/**
 * Set in checkout by payment machine before redirects to preserve cartId in
 * case of user back button click. Also set in return url for redirect payment
 * requests.
 */
export const CHECKOUT_CART_ID_QUERY_PARAM = 'cartId';
/**
 * Set by payment machine in redirect payment return url to signal that it's
 * a redirect payment. Read by payment and quotation machine.
 */
export const CHECKOUT_VERIFY_REDIRECT_PAYMENT_QUERY_PARAM =
	'verifyRedirectPayment';
/** Opaque data set by payment providers, Read by payment and quotation machine. */
export const CHECKOUT_REDIRECT_RESULTS_QUERY_PARAM = 'redirectResult';
/** Read by quotation machine. */
export const CHECKOUT_RESULT_CODE_QUERY_PARAM = 'resultCode';
/** Origin, usage unclear TODO: Investigate */
export const CHECKOUT_TYPE_QUERY_PARAM = 'type';

// Account order status order tracking queries, set externally.
export const ACCOUNT_ORDER_STATUS_CUSTOMER_ID_QUERY_PARAM = 'c';
export const ACCOUNT_ORDER_STATUS_ORDER_ID_QUERY_PARAM = 'id';

/** Brand filter list active brand. */
export const BRAND_QUERY_PARAM = 'brand';

// Blog overview queries, owned by CD.
export const BLOG_OVERVIEW_OFFSET_QUERY_PARAM = 'bo-offset';
export const BLOG_OVERVIEW_PAGE_SIZE_QUERY_PARAM = 'bo-pageSize';
export const BLOG_OVERVIEW_TAG_QUERY_PARAM = 'bo-tag';

// Inspiration overview queries, owned by CD.
export const INSPIRATION_OVERVIEW_OFFSET_QUERY_PARAM = 'io-offset';
export const INSPIRATION_OVERVIEW_PAGE_SIZE_QUERY_PARAM = 'io-pageSize';
export const INSPIRATION_OVERVIEW_TAG_QUERY_PARAM = 'io-tag';

// Product list queries, owned by CD.
export const PRODUCT_LIST_OFFSET_QUERY_PARAM = 'pl-offset';
export const PRODUCT_LIST_PAGE_SIZE_QUERY_PARAM = 'pl-pageSize';
export const PRODUCT_LIST_SORTING_QUERY_PARAM = 'pl-sortby';
